import { Subject, Observable } from 'rxjs';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class SidePanelRef<R = any> {
  private readonly closed$ = new Subject<R | undefined>();
  constructor(private closeFn: (result?: R) => void) {}

  close(result?: R) {
    this.closeFn(result);
  }

  afterClosed(): Observable<R | undefined> {
    return this.closed$.asObservable();
  }

  emitClosed(result?: R) {
    this.closed$.next(result);
    this.closed$.complete();
  }
}
